module.exports = __webpack_public_path__ + "static/media/Loan_Btn_Icon.6fe2f5af.svg";